export const translationTable = props => {
  return {
    title: props.t("ai.prompt.table.title"),
    id: props.t("ai.prompt.table.id"),
    name: props.t("ai.prompt.table.nome"),
    nome: props.t("ai.prompt.table.nome"),
    instructions: props.t("ai.prompt.table.instructions"),
    companyType: props.t("ai.prompt.table.company.type"),
    company: props.t("ai.prompt.table.company"),
    alteration: props.t("ai.prompt.table.alteration"),
    status: props.t("ai.prompt.table.status"),
    edit: props.t("ai.prompt.table.edit"),
    delete: props.t("ai.prompt.table.delete"),
    insert: props.t("ai.prompt.table.insert"),
    active: props.t("ai.prompt.table.active"),
    inactive: props.t("ai.prompt.table.inactive"),
    modalText: props.t("ai.prompt.modal.text"),
    modalConfirm: props.t("label.actions.remove.confirm"),
    modalCancel: props.t("label.actions.remove.cancel"),
  }
}

export const translationForm = props => {
  return {
    breadcrumbTitle: props.t("ai.prompt.title"),
    breadcrumbEdit: props.t("ai.prompt.form.breadcrumb.edit"),
    breadcrumbNew: props.t("ai.prompt.form.breadcrumb.new"),
    cardTitle: props.t("ai.prompt.form.card.title"),
    company: props.t("ai.prompt.form.company"),
    companyType: props.t("ai.prompt.form.company.type"),
    name: props.t("ai.prompt.form.name"),
    model: props.t("ai.prompt.form.model"),
    instructions: props.t("ai.prompt.form.instructions"),
    status: props.t("ai.prompt.form.status"),
    statusActive: props.t("ai.prompt.form.status.active"),
    statusInactive: props.t("ai.prompt.form.status.inactive"),
    save: props.t("ai.prompt.form.save"),
    remove: props.t("ai.prompt.form.remove"),
    back: props.t("ai.prompt.form.back"),
    cardTitleAlteration: props.t("ai.prompt.form.card.title.alteration"),
    alterationDate: props.t("ai.prompt.form.alteration.date"),
    alterationUser: props.t("ai.prompt.form.alteration.user"),
    error: props.t("ai.prompt.form.error"),
    errorToastPrincipal: props.t("ai.prompt.toast.error.principal"),
    errorToastInformation: props.t("ai.prompt.toast.error.information"),
    saveSuccess: props.t("ai.prompt.save.success"),
    saveError: props.t("ai.prompt.save.error"),
    editSuccess: props.t("ai.prompt.edit.success"),
    editError: props.t("ai.prompt.edit.error"),
    removeError: props.t("ai.prompt.remove.error"),
    registerError: props.t("ai.prompt.register.error"),
    removeSuccess: props.t("ai.prompt.remove.success"),
  }
}
